import Rest from '../../app/Base/Rest';

/**
 * @typedef {IndicatorService}
 */
export default class IndicatorService extends Rest {
	/**
	 * @type {String}
	 */
	static resource = '/indicator';
}
